import { Dashboard } from "../../common/dashboard/dashboard";
import ErrorBoundary from "components/elements/error-boundary/error-boundary";
export function FrontOfficeDashboard() {
  return (
    <ErrorBoundary>
      <Dashboard userType="front-office" />
    </ErrorBoundary>
  );
}
